import { Box, styled } from '@mui/material';

import { ONE_HOUR } from '../../../../config/constants';
import { ganttPxPerMs } from './gantt.constants';

export const GanttGridBox = styled(Box)({
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    zIndex: 1,
    display: 'flex',
    width: '100%',
    flex: 1,
    pointerEvents: 'none',
});
export const GanttGridStepBox = styled(Box)({
    display: 'flex',
    width: ONE_HOUR * ganttPxPerMs,
    height: '100%',
    flexShrink: 0,
    borderLeft: '1px solid #B6D2E580',
    '&:last-of-type': {
        borderRight: '1px solid #B6D2E580',
    },
});
export const GanttGridSubStepBox = styled(Box)({
    display: 'flex',
    width: '100%',
    height: '100%',
    flex: 1,
    '&:not(:first-of-type)': {
        borderLeft: '1px solid #B6D2E520',
    },
});
